import { NextSeo } from 'next-seo';
import { getPublicUrl, getSeoVisibility } from '../../appconfig';
import { metaTitleDescParenting } from '../../Constants/i18Utils.js/Parenting';
import GlobalStyle from '../../styles/globalStylesV2';
import NewFooter from '../HomePage/NewFooter';
import NewHeader from '../HomePage/NewHeader';
import { bannerData } from '../Parenting/common';
import HindiParentingArticles from '../Parenting/HindiParentingArticles';
import TopSeoCarousel from '../Parenting/TopCarouselSEO/TopSeoCarousel';

export default function ParentingHindi(props) {
  const { articleData, params, pageValue, language } = props;
  const metaTitle = metaTitleDescParenting[language].metaTitle;
  const metaDescription = metaTitleDescParenting[language].metaDescription;
  const canonicalUrl = `${getPublicUrl()}/${language}/parenting`;
  const openGraphData = {
    title: metaTitle,
    description: metaDescription,
    type: 'website',
    url: canonicalUrl,
    images: [
      {
        url: 'https://mylofamily.com/v2/static/images/512mylo.png',
        width: 512,
        height: 512,
      },
    ],
  };
  let hrefData = [];
  hrefData.push({
    hrefLang: language,
    href: canonicalUrl,
  });

  return (
    <>
      {getSeoVisibility() ? (
        <>
          <NextSeo
            title={metaTitle}
            description={metaDescription}
            openGraph={openGraphData}
            canonical={canonicalUrl}
            languageAlternates={hrefData}
          />
        </>
      ) : null}
      <GlobalStyle />
      <NewHeader showCart={true} showTrackOrder={true} nostrip={true} />
      <TopSeoCarousel data={bannerData[language]} />
      <HindiParentingArticles
        articleData={articleData}
        params={params}
        pageValue={pageValue}
        lang={language}
      />
      <NewFooter />
    </>
  );
}
